import { render, staticRenderFns } from "./RoomSubType.vue?vue&type=template&id=d9732ece"
import script from "./RoomSubType.vue?vue&type=script&lang=ts"
export * from "./RoomSubType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports